export { default } from './Core.component';
